<div class="dropdown">
    <!-- Dropdown toggle -->
    <div class="c-dropdown-toggle" (click)="toggleDrawer()">
        @if(reminderList && reminderList.length > 0){
            <div class="notif-count"><span>{{ reminderList.length }}</span></div>
        }
        <img src="assets/icons/notifications-bell.svg" />
    </div>

    <!-- Dropdown menu -->
    <div class="reminders-drawer" [class.show-drawer]="showDrawer">
        <div class="inner-wrapper_rd">
            <div class="content-wrapper_rd">
                <div class="rd-top-header">
                    <h3 i18n="@@notifications">Notifications</h3>                    
                    <img (click)="toggleDrawer()" class="close-btn" src="assets/icons/x-blue.svg">
                </div>
                <div class="wrapper_reminders-list">
                    @for (reminder of reminderList; track $index) {
                        <div class="reminder-item">
                            <div class="header">
                                <h4 (click)="goToCustomerReminders(reminder.customerId)">{{ reminder.customerName }}</h4>
                                <div>
                                    <span  class="timestamp">
                                        {{ reminder.dateCreated | date: 'MM/dd/YYYY'}} • {{ reminder.dateCreated | date: 'HH:mm a'}}
                                    </span>
                                </div>
                            </div>
                            <div class="category">
                                <ng-container i18n="@@reminders">Reminders</ng-container>
                                <span class="timestamp">
                                    <ng-container i18n="@@followUpDate">Follow Up Date</ng-container>: {{ formatDateToUTC(reminder.followUpDate) }}
                                </span>
                            </div>
                            <div class="reminder-text">
                                @if(reminder.reminder.length > textMaxLength){
                                    <div class="reminder-inner-text" [class.hovered]="isHovered[$index]" 
                                        (mouseleave)="onHover(false, $index)" >
                                        {{ truncateString(reminder.reminder) }}
                                        <img class="reminder-tooltip" src="assets/icons/info-icon-blue.svg"                                         
                                            (mouseenter)="onHover(true, $index)" 
                                            />
                                        <span class="reminder-full-text">{{ reminder.reminder }}</span>
                                    </div>
                                }
                                @else {                                    
                                    {{ reminder.reminder }}
                                }
                            </div>
                        </div>
                    }
                </div>
            </div>
        </div>
    </div>
</div>